import { PageHeader } from "@/components/layout/PageHeader";
import { ActionInbox } from "@/components/shared/ActionInbox";
import { MyDayMetricsStrip } from "@/components/shared/MyDayMetricsStrip";
import { Loading } from "@/components/shared/Loading";
import { useActions, useFinanceGateQueue, useSupplierInvoices } from "@/api/hooks";

export default function FinanceMyDay() {
  const { data: actions, isLoading } = useActions("finance");
  const { data: queue } = useFinanceGateQueue();
  const { data: apRows } = useSupplierInvoices();
  if (isLoading || !actions) return <Loading />;
  const open = actions.filter((action) => !action.done);
  const urgent = open.filter((action) => action.priority === "P1").length;

  // Item 5/13 — real, clickable metrics computed from the same Finance Gate
  // queue and AP queue the rest of Finance's screens already use (no
  // parallel aggregation, no hardcoded numbers).
  const q = queue || [];
  const awaitingReview = q.filter((row) => !row.decision).length;
  const advanceRequired = q.filter((row) => row.financeGateStatus === "ADVANCE_REQUIRED").length;
  const readyToRelease = q.filter((row) => row.decision === "RELEASED").length;
  const ap = apRows || [];
  const costVarianceOrApPending = ap.filter((row) => row.match === "Variance" || row.status === "Submitted — Pending Finance Review").length;
  const metrics = [
    { key: "awaiting-review", label: "Awaiting Finance Review", value: awaitingReview, onClick: (nav) => nav("/finance/credit"), tone: awaitingReview ? "warn" : "default" },
    { key: "advance-required", label: "Advance Required", value: advanceRequired, onClick: (nav) => nav("/finance/credit") },
    { key: "ready-to-release", label: "Ready to Release", value: readyToRelease, onClick: (nav) => nav("/finance/credit") },
    { key: "cost-variance-ap", label: "Cost Variance / AP Pending", value: costVarianceOrApPending, onClick: (nav) => nav("/finance/payables"), tone: costVarianceOrApPending ? "warn" : "default" },
  ];

  return (
    <>
      <PageHeader title="Finance workspace" subtitle={`${open.length} open financial ${open.length === 1 ? "action" : "actions"}${urgent ? ` · ${urgent} urgent` : ""}`} />
      <div className="flex-1 overflow-y-auto">
        <MyDayMetricsStrip items={metrics} />
        <div className="px-4 pt-5 md:px-6">
          <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Queue summary</div>
            <div className="mt-1 text-sm text-slate-700">
              {open.length > 0
                ? `${open.length} open ${open.length === 1 ? "item requires" : "items require"} finance review${urgent ? `, including ${urgent} urgent` : ""}.`
                : "There are no open finance actions."}
            </div>
          </div>
        </div>
        <div className="px-4 pb-1.5 pt-5 text-[11px] font-semibold uppercase tracking-wider text-slate-400 md:px-6">Action inbox</div>
        <div className="mx-4 mb-6 overflow-hidden rounded-xl border border-slate-200 bg-white md:mx-6"><ActionInbox items={actions} /></div>
      </div>
    </>
  );
}
